module.exports = __webpack_public_path__ + "asset/img/logo.23a506ae.svg";